export const selectExpensesTypes = (state) => state.expensesTypes?.expensesTypes;
